import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useExam } from '../context/ExamContext';
import { AdminHeader, CandidateHeader, PublicHeader, ReviewerHeader } from './NavigationHeaders';

export function AppShell({ children }: { children: ReactNode }) {
  const { state } = useExam();
  const location = useLocation();
  const publicPage = location.pathname === '/' || location.pathname === '/login';
  const Header = publicPage || !state.candidate ? PublicHeader : state.candidate.role === 'admin' ? AdminHeader : state.candidate.role === 'reviewer' ? ReviewerHeader : CandidateHeader;
  return <div className="min-h-screen premium-bg text-slate-50"><Header /><main>{children}</main></div>;
}
